import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { RecommendControl } from 'features/job/components/JobActionControls'
import { useNotify } from 'hooks'

export const JobRecommendControl = ({ candidate = {}, onSuccess, job }) => {
  const { t } = useTranslation()

  const { showNotification } = useNotify()

  const { id, recommended_for_job } = candidate

  const onRecommendSuccess = data => {
    onSuccess({ id, ...data })

    showNotification({
      type: 'success',
      message: t('saved_successfully'),
    })
  }

  return (
    <>
      <RecommendControl
        recommended={recommended_for_job}
        id={job?.id}
        candidate={candidate}
        onSuccess={onRecommendSuccess}
      />
    </>
  )
}

JobRecommendControl.propTypes = {
  candidate: PropTypes.object,
  onSuccess: PropTypes.func,
  job: PropTypes.any,
}
